function Madagascar({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1559)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M10.4348 15.9996V31.0044C12.1681 31.6476 14.0429 31.9996 16 31.9996C24.8365 31.9996 32 24.8361 32 15.9996C32 7.1631 10.4348 15.9996 10.4348 15.9996Z" fill="#6DA544"/>
  <path d="M16 0C14.0429 0 12.1681 0.352063 10.4348 0.995188V16H32C32 7.1635 24.8365 0 16 0Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Madagascar;
